export default __webpack_public_path__ + "static/media/improve.99d8689a.png";